import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatFormFieldModule, MatButtonModule, MatInputModule } from '@angular/material';
import { ActivationComponent } from './activation/activation.component';
import { LoginComponent } from './login/login.component';
import { NewCreateRequestComponent } from './new-create-request/new-create-request.component';
import { OrderNoteComponent } from './order-note/order-note.component';
import { RegistrationFormComponent } from './registration-form/registration-form.component';
import { TestComponent } from './test/test.component';
import { CptMasterComponent } from './AdminModule/AdminConfiguration/cpt-master/cpt-master.component';
import { PermissionComponent } from './AdminModule/AdminConfiguration/permission/permission.component';
import { RoleComponent } from './AdminModule/AdminConfiguration/role/role.component';
import { NewAppointmentComponent } from './Calender/new-appointment/new-appointment.component';
import { PatientboardReportComponent } from './Calender/patientboard-report/patientboard-report.component';
import { DocumentComponent } from './PatientChart/Document/document.component';
import { PastNotesComponent } from './PatientChart/past-notes/past-notes.component';
import { VisitNoteComponent } from './PatientChart/visit-note/visit-note.component';
import { AuthGuard } from './Services/authorization/auth.guard';
import { ResetPasswordComponent } from './UserManagement/reset-password/reset-password.component';
import { UserComponent } from './UserManagement/user/user.component';
// import { ConfigureComponent } from './admin/configure/configure.component';
import { NewMessageComponent } from './message-home/new-message/new-message.component';
import { CqmsFailingPatientsComponent } from './AdminModule/AdminConfiguration/cqms-dashboard/cqms-failing-patients/cqms-failing-patients.component';
import { ManageErxComponent } from './AdminModule/AdminConfiguration/manage-erx/manage-erx/manage-erx.component';
import { ImportDocumentComponent } from './PatientChart/Document/import-document/import-document.component';
import { ViewDocumentComponent } from './PatientChart/Document/view-document/view-document.component';
import { AssignTemplateComponent } from './PatientChart/cal-templates/assign-template/assign-template.component';
import { CalTemplateComponent } from './PatientChart/cal-templates/cal-template/cal-template.component';
import { TemplateNotesComponent } from './Template/macros/template-notes/template-notes.component';
import { CqmsQualifingCodesComponent } from './AdminModule/AdminConfiguration/cqms-dashboard/cqms-qualifing-codes/cqms-qualifing-codes.component';
import { EpcsRegistrationComponent } from './AdminModule/AdminConfiguration/epcs-console/epcs-registration/epcs-registration.component';
import { ManageExoStarUserComponent } from './AdminModule/AdminConfiguration/epcs-console/manage-exo-star-user/manage-exo-star-user.component';
import { TemplatesFormsComponent } from './Template/templates-forms/templates-forms.component';
// import { PatientAppoinmentsComponent } from './PatientChart/patient-appoinments/patient-appoinments.component';
// import { CheckedinAlertsComponent } from './Calender/checkedin/checkedin-alerts/checkedin-alerts.component';
import { FluoroscopypreviewReportComponent } from './fluoroscopypreview-report/fluoroscopypreview-report.component';
import { IntstaffChatComponent } from './intstaff-chat/intstaff-chat.component';
import { SharedComponent } from './shared/shared.component';
import { ONCCMeasureComponent } from './onccmeasure/onccmeasure.component';

const routes: Routes = [
  // { path: '', redirectTo: 'DocumentLibrary', pathMatch: 'full', },
  // { path: '', redirectTo: 'login', pathMatch: 'full', },

  { path: 'login', component: LoginComponent, data: { title: 'Login Page' } },
  { path: 'Register', component: RegistrationFormComponent },
  { path: 'Activation/:activationId/:activationCode', component: ActivationComponent },
  { path: 'Intstaffchat', component: IntstaffChatComponent },
  { path: 'Shared', component: SharedComponent },
  {
    path: '', canActivate: [AuthGuard], children: [
      { path: 'User', component: UserComponent },
      { path: 'ResetPassword', component: ResetPasswordComponent },
      { path: 'Pastnotes', component: PastNotesComponent },
      { path: 'ImportDocument', component: ImportDocumentComponent },
      { path: 'DocumentHome', component: ViewDocumentComponent },
      { path: 'Document', component: DocumentComponent },
      { path: 'cptmaster', component: CptMasterComponent },
      { path: 'Role', component: RoleComponent },
      { path: 'Permission', component: PermissionComponent },
      { path: 'newmessage', component: NewMessageComponent },
      { path: 'NewCreateRequest', component: NewCreateRequestComponent },
      { path: 'CqmsFailingPatient', component: CqmsFailingPatientsComponent },
      { path: 'CalTemplate', component: CalTemplateComponent },
      { path: 'AssignTemplate', component: AssignTemplateComponent },
      { path: 'CqmsQualifyingCodes', component: CqmsQualifingCodesComponent },
      { path: 'EpcsRegistration/:userId', component: EpcsRegistrationComponent },
      { path: 'EpcsRegistration', component: EpcsRegistrationComponent },
      { path: 'ManageExoStar/:userId', component: ManageExoStarUserComponent },
      { path: 'ManageExoStar', component: ManageExoStarUserComponent },
      { path: 'TemplatesForms', component: TemplatesFormsComponent },
      { path: 'FluoroscopyPR', component: FluoroscopypreviewReportComponent },
      { path: 'AdminDashboard', component: ONCCMeasureComponent },
      {
        path: 'MyProfile',
        loadChildren: () => import('./my-profile/my-profile.module').then((x) => x.MyProfileModule)
      },
      {
        path: 'StaffCalender',
        loadChildren: () => import('./Calender/staff-calender/staff-leaves.module').then((x) => x.StaffLeavesModule)
      },
      {
        path: 'ChangePassword',
        loadChildren: () => import('./change-password/change-password.module').then((m) => m.ChangePasswordModule)
      },

      {
        path: 'Settings',
        loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule)
      },
      {
        path: 'ProviderCalender',
        loadChildren: () => import('./Calender/provider-calender/provider-calander.module').then((m) => m.ProviderCalanderModule)
      },

      {
        path: '',
        loadChildren: () => import('./PatientChart/OR-Note/encounter-note/or-record/or-record.module').then((m) => m.OrRecordModule)
      },
      {
        path: '',
        loadChildren: () => import('./PatientChart/visit-note/visit-note.module').then((m) => m.VisitNoteModule)
      },
      {
        path: '',
        loadChildren: () => import('./AdminModule/admin-module.module').then((x) => x.AdminModuleModule)
      },
      {
        path: '',
        loadChildren: () => import('./document-library/document-library.module').then((x) => x.DocumentLibraryModule)
      },
      {
        path: '',
        loadChildren: () => import('./PatientChart/Demographics/demographics.module').then((x) => x.DemographicsModule)
      },
      {
        path: '',
        loadChildren: () => import('./message/messages.module').then((x) => x.MessagesModule)
      },
      {
        path: '',
        loadChildren: () => import('./home-orders/trackers.module').then((x) => x.TrackersModule)
      },
      {
        path: '',
        loadChildren: () => import('./Template/template.module').then((x) => x.TemplateModule)
      },
      {
        path: '',
        loadChildren: () => import('./AdminModule/AdminConfiguration/audit-trail/audit-trail.module').then((x) => x.AuditTrailModule)
      },
      {
        path: '',
        loadChildren: () => import('./dashboard.module').then((x) => x.DashboardModule)
      },
      {
        path: '',
        loadChildren: () => import('./patient-portal/patient-portal.module').then((x) => x.PatientPortalModule)
      },

    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes), MatButtonModule, MatDialogModule,
  //  DynamicFormBuilderModule, 
  RouterModule.forChild(routes)],
  exports: [RouterModule, FormsModule, MatDialogModule, MatFormFieldModule, MatButtonModule, MatInputModule],

  // providers: [CanDeactivateGuard]
})
export class AppRoutingModule { }
export const Routings = [
  LoginComponent,
  VisitNoteComponent,
  RegistrationFormComponent,
  ImportDocumentComponent,
  ViewDocumentComponent,
  DocumentComponent,
  UserComponent,
  ResetPasswordComponent,
  NewAppointmentComponent,
  PastNotesComponent,
  PatientboardReportComponent,
  TestComponent,
  OrderNoteComponent,
  TemplateNotesComponent,
  ManageErxComponent,
  ActivationComponent,
  CptMasterComponent,
  RoleComponent,
  PermissionComponent];
